import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getHomePath } from "Sections/Home/routes";

import Payout from "Sections/payout";

const BookingSettings = ({ userMode, router }) => {
  useEffect(() => {
    if (userMode !== "lister") {
      router.push(getHomePath());
    }
  }, []);

  return <Payout />;
};

BookingSettings.propTypes = {
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  userMode: PropTypes.oneOf(["lister", "seeker"]).isRequired,
};

export default BookingSettings;
